class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.innerHTML.trim()) return; // already server-rendered (e.g. via section fetch)
    const url = this.dataset.url;
    const sectionId = this.dataset.sectionId;
    if (!url || !sectionId) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const wrapper = doc.querySelector(`#shopify-section-${sectionId}`);
        const content = wrapper?.querySelector('product-recommendations');
        if (content && content.textContent.trim()) {
          this.innerHTML = content.innerHTML;
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
